// extracted by mini-css-extract-plugin
export default {"categoryLabel":"task-category-label_categoryLabel__Kf8HT"};